import { Dayjs } from 'dayjs';
import { PickersDay, PickersDayProps } from '@mui/x-date-pickers/PickersDay';

export interface RangeDayProps extends PickersDayProps<Dayjs> {
  rangeStart?: Dayjs | null;
  rangeEnd?: Dayjs | null;
}

/** Calendar day cell that highlights the currently selected start/end and the days between. */
const RangeDay = ({ rangeStart, rangeEnd, day, ...other }: RangeDayProps) => {
  const isStart = !!rangeStart && day.isSame(rangeStart, 'day');
  const isEnd = !!rangeEnd && day.isSame(rangeEnd, 'day');
  const isBetween = !!rangeStart && !!rangeEnd && day.isAfter(rangeStart, 'day') && day.isBefore(rangeEnd, 'day');

  return (
    <PickersDay
      {...other}
      day={day}
      selected={isStart || isEnd}
      sx={{
        ...(isBetween && {
          backgroundColor: 'color-mix(in srgb, var(--color-steelblue) 15%, transparent)',
          borderRadius: 0,
        }),
        '&.Mui-selected, &.Mui-selected:hover, &.Mui-selected:focus': {
          backgroundColor: 'var(--color-steelblue)',
        },
      }}
    />
  );
};

export default RangeDay;
